module.exports = __webpack_public_path__ + "img/access-light.5cff105c.svg";